import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import { EaDisplay } from '@app/components/pr-display';

@Component({
    selector: 'pr-notification',
    templateUrl: './pr-notification.component.html',
    styleUrls: ['./pr-notification.component.scss'],
    standalone: false
})
export class PrNotificationComponent implements AfterViewInit {
  @ViewChild('wrapper') public wrapper: ElementRef;

  @Input() display: EaDisplay;
  @Input() title: string;
  @Input() description: string;
  @Input() timeout: number = 3000;

  @Output() onDismiss: EventEmitter<any> = new EventEmitter();

  constructor() {}

  get icon() {
    switch (this.display) {
      case EaDisplay.danger:
        return 'fa-exclamation-triangle';
      case EaDisplay.success:
        return 'fa-check-circle-o';
      case EaDisplay.warning:
        return 'fa-exclamation-circle ';
      default:
        return 'fa-info-circle';
    }
  }

  click() {
    this.onDismiss.emit();
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.wrapper.nativeElement.classList.add('open');
    }, 50);
  }

  close() {
    this.wrapper.nativeElement.classList.remove('open');
    setTimeout(() => {
      this.wrapper.nativeElement.classList.add('dismiss');
    }, 500);
  }
}
